import type { Location } from 'react-router-dom';
import { OrderStatus } from 'src/types';
import { EditOrderGuardInput, EditOrderGuardResult } from 'src/types/loaders';
import { isCustomerSuccessOrSalesUser, isLabTech } from 'src/utils';

type LdtOrderEditFields = {
  id: string;
  status: OrderStatus;
};

export function getRowLink(
  order: LdtOrderEditFields,
  organization: string,
  location: Location,
  userId: string,
): {
  pathname: string;
  state: { background: { pathname: string; search: string } };
} {
  if (isLabTech() && canEditOrder(order, userId)) {
    return {
      pathname: `/${organization}/orders/${order.id}/edit`,
      state: {
        background: { pathname: location.pathname, search: location.search },
      },
    };
  }

  return {
    pathname: `/${organization}/orders/${order.id}`,
    state: {
      background: { pathname: location.pathname, search: location.search },
    },
  };
}

export function canEditOrder(
  order: LdtOrderEditFields,
  _userInfoId: string,
): boolean {
  if (isLabTech()) {
    return [OrderStatus.Draft, OrderStatus.QualityControlApproved].includes(
      order.status,
    );
  } else if (isCustomerSuccessOrSalesUser()) {
    return [
      OrderStatus.Draft,
      OrderStatus.QualityControlPending,
      OrderStatus.QualityControlApproved,
    ].includes(order.status);
  } else {
    return false;
  }
}

export function getEditOrderRedirect(
  input: EditOrderGuardInput,
): EditOrderGuardResult {
  const { order, redirectBasePath, orderId: orderId } = input;
  const ordersListPath = `${redirectBasePath}/orders`;

  if (!canEditOrder(order, input.userId)) {
    if (isLabTech()) {
      return {
        redirectPath: ordersListPath,
        errorMessage: 'This order cannot be edited at this time.',
      };
    } else if (isCustomerSuccessOrSalesUser()) {
      return {
        redirectPath: `${redirectBasePath}/orders/${orderId}`,
        errorMessage: 'This order cannot be edited at this time.',
      };
    } else {
      return {
        redirectPath: ordersListPath,
        errorMessage: 'You are not authorized to edit this order.',
      };
    }
  }

  return null;
}
